import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import {
  getSpecificDetails,
  postDataByID,
  updateData,
} from '../../service/ApiService';
import {
  APPROVE_DOCUMENT,
  EDIT_DOCUMENT,
  TAX_LIST_DETAIL,
  UPDATE_TAXPAYER_NOTE,
} from '../../config/ApiConstant';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { TaxListDetailColumns } from '../../appconfig/DatatableSetting';
import { Column } from 'primereact/column';
import { formatdate, formatDate } from '../../appconfig/AppHelper';
import { InputSwitch } from 'primereact/inputswitch';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import FileUploader from '../../components/FileUploader/FileUploader';
import Loader from '../../components/Loader/Loader';
import ViewSinNumber from '../../components/ViewSinNumber/ViewSinNumber';
import { User, Briefcase, List, Receipt, FileText } from 'lucide-react';
import {
  SkeletonbodyTemplate,
  Skeletonitems,
} from '../../appconfig/Settings';
import {
  InfoCard,
  Section,
  StatusBadge,
} from '../../components/CommonCompentUi';
import { validateFileUpload } from '../../config/Validate';
import { InputText } from 'primereact/inputtext';

interface UserTaxDetailProps {
  data?: any;
  loading?: boolean;
  refreshData?: () => void;
}

const UserTaxDetail = ({ data, loading, refreshData }: UserTaxDetailProps) => {

  // tax payer id
  const { id } = useParams();
  const employee_id = id ? atob(id) : null;

  // toast ref
  const toast = useRef<any>(null);

  // tax payer detail
  const [userTaxFileData, setUserTaxFileData] = useState<any>(null);

  // tax payer property owner and property share obj
  const [propertyOwnerNameAndShare, setPropertyOwnerNameAndShare] =
    useState<any>({});

  // tax payer general expenses obj
  const [generalExpensesList, setGeneralExpensesList] = useState<any>({});

  // self employed expenses
  const [selfEmployedExpensesList, setSelfEmployedExpensesList] = useState<any>(
    {},
  );

  // self employd other expenses list
  const [selfEmployedOtherExpensesList, setSelfEmployedOtherExpensesList] =
    useState<any>({});

  // work from home expenses list
  const [wfhExpensesList, setWfhExpensesList] = useState<any>({});

  // work from home other expenses list
  const [wfhOtherExpensesList, setWfhOtherExpensesList] = useState<any>({});

  // filters
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [globalFilter, setGlobalFilter] = useState<any>(null);

  // loading
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // doc list
  const [documentList, setDocumentList] = useState<any>([]);

  // tax payer spouse data
  const [spouseData, setSpouseData] = useState<any>({});

  // active tax payer id
  const [activeTaxPayerId, setActiveTaxPayerId] = useState<any>(null);

  // doc status & doc Dialog
  const [documentStatus, setDocumentStatus] = useState<any>(null);
  const [documentStatusDialog, setDocumentStatusDialog] =
    useState<boolean>(false);

  // tax payer landlord details
  const [landlordDetails, setLandlordDetails] = useState<any>();

  // tax payer other expenses array
  const [otherExpensesDetail, setOtherExpensesDetail] = useState<any>([]);

  // tax payer dependent child array
  const [dependentChildDetails, setDependentChildDetails] = useState<any>([]);

  // is hold
  const [isHold, setIsHold] = useState<any>(null);

  // file upload dialog & selected file
  const [fileUploadDialog, setFileUploadDialog] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<any>(null);

  // edit name dialog
  const [editNameDialog, setEditNameDialog] = useState<boolean>(false);
  const [editFirstName, setEditFirstName] = useState<string>('');
  const [editLastName, setEditLastName] = useState<string>('');
  const [editNameLoading, setEditNameLoading] = useState<boolean>(false);
  const [editNameField, setEditNameField] = useState<
    'first_name' | 'middle_name' | 'last_name' | null
  >(null);

  // error obj
  const [errors, setErrors] = useState<any>({});

  // tax payer available dates to visit for tax filing
  const [availableDatesToVisit, setAvailableDatesToVisit] = useState<any>([]);

  // sin copied state
  const [sinCopied, setSinCopied] = useState<boolean>(false);

  // current year
  const current = new Date();
  const year = current.getFullYear();

  // scroll position
  const scrollPositionRef = useRef(0);

  // Marital status derived state
  const isMarried = userTaxFileData?.dec_marrige_status === 'Married' || userTaxFileData?.dec_marrige_status === 'Living common-law';

  // Collapsible sections state
  const [expandedSections, setExpandedSections] = useState<any>({
    personal: true,
    dependentChild: true,
    employment: true,
    general: true,
    expenses: true,
    documents: true,
    rentBenefit: true,
    workFromHomeExpense: true,
    employedExpenses: true,
    otherIncomeInformation: true,
  });

  // useEffect to parse tax payer detail when and data changes
  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      parseTaxData(data);
    }
  }, [data]);

  // Handle scroll position in tab
  useLayoutEffect(() => {
    window.scrollTo({
      top: scrollPositionRef.current,
      behavior: 'auto',
    });
  }, [expandedSections]);

  // on input file change
  const onInputFileChange = (e: any) => {
    let val = e?.files;

    if (e?.files) {
      val = e.files;
    }

    setSelectedFile(val);
    setErrors({});
  };

  // parse tax payer detail
  const parseTaxData = (response: any) => {
    let spousedetails = {};
    let landlordNames = [];
    let otherExpenses = [];
    let availableSlotDate = [];
    let childDetails = [];
    let selfEmployedOtherExpense = [];
    let wfhEmployedOtherExpense = [];

    if (response?.spouse_details) {
      spousedetails = JSON.parse(response.spouse_details);
    }
    if (response?.rent_obj) {
      landlordNames = JSON.parse(response?.rent_obj);
    }
    if (response?.other_expenses) {
      otherExpenses = JSON.parse(response?.other_expenses);
    }
    if (response?.child_details) {
      childDetails = JSON.parse(response?.child_details);
    }
    if (response?.slot) {
      availableSlotDate = JSON.parse(response?.slot?.date);
    }

    if (response?.employed_other_income) {
      selfEmployedOtherExpense = JSON.parse(response?.employed_other_income);
    }
    if (response?.work_from_home_other_expense) {
      wfhEmployedOtherExpense = JSON.parse(
        response?.work_from_home_other_expense,
      );
    }

    const userDataDocs = response?.user_docs;
    setUserTaxFileData(response);

    // property owner name with % of property
    setPropertyOwnerNameAndShare(
      response?.owner_with_percentage
        ? JSON.parse(response?.owner_with_percentage)
        : {},
    );

    // general rent expenses
    setGeneralExpensesList(
      response?.expenses ? JSON.parse(response.expenses) : {},
    );

    // general other expenses
    setOtherExpensesDetail(otherExpenses);

    // Dependent Child detail
    setDependentChildDetails(childDetails);

    // tax payer document list
    setDocumentList(userDataDocs);

    // spouse details
    setSpouseData(spousedetails);

    // landlord details name, amount, months
    setLandlordDetails(landlordNames);

    // available slots within which tax filing will be done
    setAvailableDatesToVisit(availableSlotDate);

    // self employed other expenses detail
    setSelfEmployedOtherExpensesList(selfEmployedOtherExpense);

    // work from home other expenses detail
    setWfhOtherExpensesList(wfhEmployedOtherExpense);

    // self employed general expenses
    setSelfEmployedExpensesList(
      response?.employed_income ? JSON.parse(response?.employed_income) : {},
    );

    // work from home general expenses
    setWfhExpensesList(
      response?.work_from_home_expense
        ? JSON.parse(response?.work_from_home_expense)
        : {},
    );
    setPageLoad(true);
  };

  // update doc status api call
  const documentStatusUpdateApiCall = async () => {
    try {
      setSubmitLoading(true);
      const response = await postDataByID(APPROVE_DOCUMENT, activeTaxPayerId);
      if (response) {
        setDocumentStatusDialog(false);
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response?.message,
        });
        setPageLoad(true);
        setSubmitLoading(false);
        if (refreshData) {
          refreshData();
        }
      }
    } catch (error: any) {
      setPageLoad(false);
      setSubmitLoading(false);
      setDocumentStatusDialog(false);
      toast.current?.show({
        severity: 'error',
        summary: 'Alert',
        detail: error?.response?.data?.message,
      });
      setPageLoad(false);
    }
    setDocumentStatus(true);
  };

  // file upload api call
  const fileUploadSubmit = async () => {
    try {
      const { errors, isError } = validateFileUpload(selectedFile);
      setErrors(errors);
      if (isError) return;
      setSubmitLoading(true);

      const formData = new FormData();
      if (selectedFile instanceof File) {
        formData.append('file', selectedFile);
      }
      const response = await updateData(
        EDIT_DOCUMENT,
        activeTaxPayerId,
        formData,
      );
      if (response) {
        setFileUploadDialog(false);
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response?.message,
        });
        setSubmitLoading(false);
        if (refreshData) {
          refreshData();
        }
        setSelectedFile(null);
      }
    } catch (error: any) {
      setSubmitLoading(false);
      setFileUploadDialog(false);
      setSelectedFile(null);
      toast.current?.show({
        severity: 'error',
        summary: 'Alert',
        detail: error?.response?.data?.message,
      });
    }
  };



  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData?.file_url) {
      window.open(rowData?.file_url, '_blank');
    } else {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'PDF NOT FOUND',
      });
    }
  };

  // action body template to view pdf
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: 'bottom' }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );





  // hide doc status dialog
  const hideDocStatusDialog = () => {
    setDocumentStatusDialog(false);
    setActiveTaxPayerId(null);
    setDocumentStatus(null);
  };

  // hide file upload dialog
  const hideFileUploadDialog = () => {
    setFileUploadDialog(false);
    setActiveTaxPayerId(null);
    setSelectedFile(null);
  };

  const handleSinCopy = () => {
    navigator.clipboard.writeText(String(userTaxFileData?.sin_number || "—"));
    setSinCopied(true);
    setTimeout(() => {
      setSinCopied(false);
    }, 5000);
  };

  // open edit name dialog
  const openEditNameDialog = (field: 'first_name' | 'middle_name' | 'last_name') => {
    setEditNameField(field);
    if (field === 'first_name') {
      setEditFirstName(userTaxFileData?.first_name || '');
    } else if (field === 'middle_name') {
      setEditFirstName(userTaxFileData?.middle_name || '');
    } else {
      setEditLastName(userTaxFileData?.last_name || '');
    }
    setEditNameDialog(true);
  };

  // hide edit name dialog
  const hideEditNameDialog = () => {
    setEditNameDialog(false);
    setEditFirstName('');
    setEditLastName('');
    setEditNameField(null);
    setEditNameLoading(false);
    setErrors({});
  };

  // save edit name handler
  const saveEditNameHandler = async () => {
    const nameErrors: any = {};
    if (editNameField === 'first_name' && !editFirstName.trim()) {
      nameErrors['first_name'] = 'First name is required';
    }
    if (editNameField === 'middle_name' && !editFirstName.trim()) {
      nameErrors['middle_name'] = 'Middle name is required';
    }
    if (editNameField === 'last_name' && !editLastName.trim()) {
      nameErrors['last_name'] = 'Last name is required';
    }
    if (Object.keys(nameErrors).length > 0) {
      setErrors(nameErrors);
      return;
    }
    try {
      setEditNameLoading(true);
      const payload: any = {};
      if (editNameField === 'first_name') {
        payload.first_name = editFirstName.trim();
      } else if (editNameField === 'middle_name') {
        payload.middle_name = editFirstName.trim();
      } else {
        payload.last_name = editLastName.trim();
      }
      const response = await updateData(
        UPDATE_TAXPAYER_NOTE,
        employee_id,
        payload,
      );
      if (response) {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response?.message || 'Name updated successfully',
        });
        hideEditNameDialog();
        if (refreshData) {
          refreshData();
        }
      }
    } catch (error: any) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: error?.response?.data?.message || 'Failed to update name',
      });
    } finally {
      setEditNameLoading(false);
    }
  };

  // on document status change
  const onStatusChange = (rowData: any, e: any) => {
    setActiveTaxPayerId(rowData?.id);
    setDocumentStatus(e.target.value);
    setDocumentStatusDialog(true);
    if (rowData.status === 'Approved') {
      setIsHold(1);
    } else {
      setIsHold(0);
    }
  };

  // on File upload change
  const onFileUpload = (rowData: any, e: any) => {
    setActiveTaxPayerId(rowData?.id);
    setFileUploadDialog(true);
  };

  // doc status template
  const documentStatusTemplate = (rowData: any) => {
    let statusClass: any =
      rowData.status === 'Not Approved' ? 'warning' : 'success';
    return (
      <div className="actions flex flex-column align-items-center">
        <InputSwitch
          className="mr-2 mb-2"
          value={documentStatus}
          disabled={rowData?.status === 'Not Approved'}
          checked={rowData?.status === 'Not Approved' ? false : true}
          onChange={(e) => onStatusChange(rowData, e)}
        />
        <Badge
          severity={statusClass}
          value={
            rowData.status === 'Not Approved' ? 'Not Approved' : 'Approved'
          }
          style={{ width: 'fit-content' }}
        ></Badge>
      </div>
    );
  };

  // upload file template
  const uploadFileTemplate = (rowData: any) => {
    return (
      <div className="name">
        <Button
          tooltip={'Upload Doc'}
          tooltipOptions={{ position: 'bottom' }}
          className="ml-2 common-primary-button"
          icon="pi pi-file-edit"
          disabled={rowData?.status === 'Approved'}
          label=""
          onClick={(e) => onFileUpload(rowData, e)}
        />
      </div>
    );
  };

  // tax filing completed within dates
  const taxFilingCompletedWithin = () => {
    if (!window.cn(availableDatesToVisit)) {
      const firstDate = availableDatesToVisit[0];
      const lastDate = availableDatesToVisit[availableDatesToVisit?.length - 1];
      return `${formatDate(firstDate)} to ${formatDate(lastDate)}`;
    }
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="tax-payer-modern-container">
        <div className="content-wrapper">
          {userTaxFileData && (
            <>
              {/* Personal Details Section */}
              <Section
                title="Tax Payer Details"
                icon={User}
                sectionKey="personal"
                scrollPositionRef={scrollPositionRef}
                expandedSections={expandedSections}
                setExpandedSections={setExpandedSections}
              >
                <div className="grid">
                  <div className="col-12 md:col-6">
                    <div className="flex align-items-center mb-2 w-full border-bottom-1 border-100 h-full">
                      <div className="font-normal mr-2" style={{ width: "50%", minWidth: "130px", color: "#555", fontSize: "14px" }}>SIN Number:</div>
                      <div style={{ flex: 1 }} className="flex align-items-center gap-2">
                        <ViewSinNumber
                          value={userTaxFileData?.sin_number}
                          label="Sin Number"
                        />
                        {userTaxFileData?.sin_number && userTaxFileData?.sin_number !== "-" && userTaxFileData?.sin_number !== "—" && (
                          <i
                            className={`pi ${sinCopied ? "pi-check text-green-500" : "pi-copy text-500 hover:text-primary"} cursor-pointer`}
                            style={{ fontSize: '0.9rem', flexShrink: 0 }}
                            onClick={handleSinCopy}
                            title={sinCopied ? "Copied!" : "Copy"}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 md:col-6 mt-2">
                    <InfoCard
                      label="Date of Birth"
                      value={
                        userTaxFileData?.date_of_birth
                          ? formatDate(userTaxFileData?.date_of_birth)
                          : '—'
                      }
                      allowCopy={true}
                      labelWidth="50%"
                      pb="pb-3"
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="First Name"
                      value={userTaxFileData?.first_name || '—'}
                      allowCopy={true}
                      labelWidth="50%"
                      action={
                        <i
                          className="pi pi-pencil cursor-pointer text-500 hover:text-primary"
                          style={{ fontSize: '0.9rem' }}
                          onClick={() => openEditNameDialog('first_name')}
                          title="Edit First Name"
                        />
                      }
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="Middle Name"
                      value={userTaxFileData?.middle_name || '—'}
                      allowCopy={true}
                      labelWidth="50%"
                      action={
                        <i
                          className="pi pi-pencil cursor-pointer text-500 hover:text-primary"
                          style={{ fontSize: '0.9rem' }}
                          onClick={() => openEditNameDialog('middle_name')}
                          title="Edit Middle Name"
                        />
                      }
                    />
                  </div>
                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="Last Name"
                      value={userTaxFileData?.last_name || '—'}
                      allowCopy={true}
                      labelWidth="50%"
                      action={
                        <i
                          className="pi pi-pencil cursor-pointer text-500 hover:text-primary"
                          style={{ fontSize: '0.9rem' }}
                          onClick={() => openEditNameDialog('last_name')}
                          title="Edit Last Name"
                        />
                      }
                    />
                  </div>
                  <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                    <InfoCard
                      label="Email"
                      value={userTaxFileData?.email || '—'}
                      allowCopy={true}
                      labelWidth={isMarried ? "24.5%" : "50%"}
                    />
                  </div>
                  <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                    <InfoCard
                      label="Street Address"
                      value={userTaxFileData?.street_address || '—'}
                      allowCopy={true}
                      labelWidth={isMarried ? "24.5%" : "50%"}
                    />
                  </div>
                  <div className="col-12 md:col-6">
                    <InfoCard label="City" value={userTaxFileData?.city || '—'} allowCopy={true} labelWidth="50%" />
                  </div>
                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="Province"
                      value={userTaxFileData?.province || '—'}
                      allowCopy={true}
                      labelWidth="50%"
                    />
                  </div>
                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="Postal Code"
                      value={userTaxFileData?.postal_code || '—'}
                      allowCopy={true}
                      labelWidth="50%"
                    />
                  </div>
                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="Phone Number"
                      value={userTaxFileData?.phone || '—'}
                      allowCopy={true}
                      labelWidth="50%"
                    />
                  </div>
                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="Marital Status on Dec 31"
                      value={userTaxFileData?.dec_marrige_status || '—'}
                      labelWidth="50%"
                    />
                  </div>

                  {/* <InfoCard label="Marital Status" value={userTaxFileData?.dec_marrige_status === "Married" ? "Married" : "Not Married"} /> */}
                  {userTaxFileData?.dec_marrige_status !== 'Single' && (
                    <div className="col-12 md:col-6">
                      <InfoCard
                        label="Marital Status Changed Date"
                        value={
                          userTaxFileData?.marrige_status_changed_date
                            ? formatDate(
                              userTaxFileData?.marrige_status_changed_date,
                            )
                            : '—'
                        }
                        labelWidth="60%"
                      />
                    </div>
                  )}
                  <div className="col-12 md:col-6">
                    <InfoCard
                      label="Status in canada"
                      value={
                        userTaxFileData.canadian_status
                          ? `${userTaxFileData.canadian_status}`
                          : '—'
                      }
                      highlight
                      labelWidth={isMarried ? "50%" : "50%"}
                    />
                  </div>

                </div>
              </Section>
              {/* dependent child section */}
              { }
              {dependentChildDetails?.length > 0 && (
                <Section
                  title="Dependent Child Details"
                  icon={User}
                  sectionKey="dependentChild"
                  scrollPositionRef={scrollPositionRef}
                  expandedSections={expandedSections}
                  setExpandedSections={setExpandedSections}
                >
                  <div className="mt-4">
                    <DataTable
                      value={dependentChildDetails}
                      showGridlines
                      stripedRows
                      className="p-datatable-sm"
                      responsiveLayout="scroll"
                    >
                      <Column
                        field="child_name"
                        header="Child Name"
                        headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                        style={{ padding: '7px 10px' }}
                        body={(rowData) => rowData?.child_name || '—'}
                      />
                      <Column
                        field="child_dob"
                        header="Date of Birth"
                        headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                        style={{ padding: '7px 10px' }}
                        body={(rowData) =>
                          !window.cn(rowData.child_dob)
                            ? `${formatdate(rowData.child_dob)}`
                            : '—'
                        }
                      />
                    </DataTable>
                  </div>
                </Section>
              )}

              {/* Employment & Income Section */}
              <Section
                title="Employment & Income"
                icon={Briefcase}
                sectionKey="employment"
                scrollPositionRef={scrollPositionRef}
                expandedSections={expandedSections}
                setExpandedSections={setExpandedSections}
              >
                <div className="section-content-wrapper">
                  <div className="badges-container flex gap-3 mb-2">
                    <StatusBadge
                      status={
                        userTaxFileData?.first_time_form_filling_status === true
                          ? 'First Time Filer'
                          : 'Not First Time Filer'
                      }
                      type="info"
                    />
                    <StatusBadge
                      status={
                        userTaxFileData?.payment_status === 'Completed'
                          ? 'Payment Completed'
                          : 'Payment Pending'
                      }
                      type={
                        userTaxFileData?.payment_status === 'Completed'
                          ? 'success'
                          : 'warning'
                      }
                    />
                  </div>

                  <div className="grid">
                    {userTaxFileData?.first_time_form_filling_status ===
                      true && (
                        <>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Date of Entry"
                              value={
                                userTaxFileData?.date_of_entry
                                  ? formatDate(userTaxFileData?.date_of_entry)
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Income from Home"
                              value={
                                userTaxFileData.income_from_home
                                  ? `$${userTaxFileData.income_from_home}`
                                  : '—'
                              }
                              highlight
                              labelWidth="60%"
                            />
                          </div>
                        </>
                      )}

                    {userTaxFileData?.moved_from_province === true && (
                      <>
                        <div className="col-12 md:col-6">
                          <InfoCard
                            label="Moving Date"
                            value={
                              userTaxFileData?.moving_date
                                ? formatDate(userTaxFileData?.moving_date)
                                : '—'
                            }
                            labelWidth="60%"
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <InfoCard
                            label="Province From"
                            value={userTaxFileData?.province_from || '—'}
                            labelWidth="60%"
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <InfoCard
                            label="Province To"
                            value={userTaxFileData?.province_to || '—'}
                            labelWidth="60%"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Section>

              {/* Rent Benefit section */}
              <div className="grid">
                <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                  <Section
                    title="Rent Benefit"
                    icon={Briefcase}
                    sectionKey="rentBenefit"
                    scrollPositionRef={scrollPositionRef}
                    expandedSections={expandedSections}
                    setExpandedSections={setExpandedSections}
                  >
                    <div className="section-content-wrapper">
                      <div className="grid">
                        <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                          <InfoCard
                            label="Rent Benefit Status"
                            value={
                              userTaxFileData?.benefit_status === true
                                ? 'Eligible'
                                : 'Not Eligible'
                            }
                            labelWidth={isMarried ? "40%" : "60%"}
                          />
                        </div>
                      </div>

                      {landlordDetails?.length > 0 && (
                        <div className="mt-4">
                          <h5 className="mb-3">Landlord Details</h5>
                          <DataTable
                            value={landlordDetails}
                            showGridlines
                            stripedRows
                            className="p-datatable-sm"
                            responsiveLayout="scroll"
                          >
                            <Column
                              field="name"
                              header="Landlord Name"
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={(rowData) => rowData?.name || '—'}
                            />
                            <Column
                              field="amount"
                              header="Rent Paid Per Month"
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={(rowData) =>
                                !window.cn(rowData.amount)
                                  ? `$${rowData.amount}`
                                  : '—'
                              }
                            />
                            <Column
                              field="months"
                              header="Months You Paid Rent"
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={(rowData) =>
                                !window.cn(rowData.months)
                                  ? `${rowData.months}`
                                  : '—'
                              }
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </Section>
                </div>

                <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                  {/* General Information Section */}
                  <Section
                    title="General Information"
                    icon={List}
                    sectionKey="general"
                    scrollPositionRef={scrollPositionRef}
                    expandedSections={expandedSections}
                    setExpandedSections={setExpandedSections}
                  >
                    <div className="grid">
                      {!window.cn(userTaxFileData?.child_care_expense) && (
                        <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                          <InfoCard
                            label="Child Care Expense"
                            value={
                              userTaxFileData.child_care_expense
                                ? `${userTaxFileData.child_care_expense}`
                                : '—'
                            }
                            highlight
                            labelWidth={isMarried ? "40%" : "60%"}
                          />
                        </div>
                      )}

                      {!window.cn(userTaxFileData?.donation_amount) && (
                        <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                          <InfoCard
                            label="Donation Amount"
                            value={
                              userTaxFileData.donation_amount
                                ? `${userTaxFileData.donation_amount}`
                                : '—'
                            }
                            highlight
                            labelWidth={isMarried ? "40%" : "60%"}
                          />
                        </div>
                      )}

                      {!window.cn(userTaxFileData?.medical_expense) && (
                        <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                          <InfoCard
                            label="Medical Expense"
                            value={
                              userTaxFileData.medical_expense
                                ? `${userTaxFileData.medical_expense}`
                                : '—'
                            }
                            highlight
                            labelWidth={isMarried ? "40%" : "60%"}
                          />
                        </div>
                      )}
                    </div>
                  </Section>
                </div>
              </div>

              {/* Other Income Information Section */}
              <Section
                title="Other Income Information"
                icon={List}
                sectionKey="otherIncomeInformation"
                scrollPositionRef={scrollPositionRef}
                expandedSections={expandedSections}
                setExpandedSections={setExpandedSections}
              >
                <div className="grid">
                  <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                    <InfoCard
                      label="First Time Home Buyer"
                      value={
                        userTaxFileData?.first_time_home_buyer === true
                          ? 'Yes'
                          : 'No'
                      }
                      labelWidth={isMarried ? "40%" : "60%"}
                    />
                  </div>
                  <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                    <InfoCard
                      label="Property Sold (Current Year)"
                      value={
                        userTaxFileData?.property_sell === true ? 'Yes' : 'No'
                      }
                      labelWidth={isMarried ? "40%" : "60%"}
                    />
                  </div>
                  <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                    <InfoCard
                      label="Property Greater Than $100,000"
                      value={
                        userTaxFileData?.property_more_than_1_lakh === true
                          ? 'Yes'
                          : 'No'
                      }
                      labelWidth={isMarried ? "40%" : "60%"}
                    />
                  </div>
                  <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                    <InfoCard
                      label="Applied for Northern Resident Benefit"
                      value={
                        userTaxFileData?.northern_resident_benefit === '1' ? 'Yes' : 'No'
                      }
                      labelWidth={isMarried ? "40%" : "60%"}
                    />
                  </div>
                  {userTaxFileData?.form_note && (
                    <div className="col-12">
                      <div className="flex flex-column mb-1 w-full p-2" style={{ backgroundColor: "#f9fafb", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
                        <div className="font-semibold mb-2" style={{ color: "#374151", fontSize: "14px" }}>Note:</div>
                        <div style={{ color: "#4b5563", fontSize: "14px", lineHeight: "1.5", whiteSpace: "pre-wrap" }}>
                          {userTaxFileData?.form_note}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Section>

              {/* Expenses Section */}
              {userTaxFileData?.rental_income === true && (
                <Section
                  title="Rent Information"
                  icon={Receipt}
                  sectionKey="expenses"
                  scrollPositionRef={scrollPositionRef}
                  expandedSections={expandedSections}
                  setExpandedSections={setExpandedSections}
                >
                  <div className="section-content-wrapper">
                    <div className="grid">
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Rental Income"
                          value={
                            userTaxFileData?.rental_income === true ? 'Yes' : 'No'
                          }
                          labelWidth="60%"
                        />
                      </div>

                      {userTaxFileData?.rental_income === true && (
                        <>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Income from Rental Property"
                              value={
                                userTaxFileData.rental_amount
                                  ? `$${userTaxFileData.rental_amount}`
                                  : '—'
                              }
                              highlight
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Property Owner Name"
                              value={
                                propertyOwnerNameAndShare?.property_owner_name ||
                                '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Share of Property Owner"
                              value={
                                propertyOwnerNameAndShare?.share_of_property_owner
                                  ? `${propertyOwnerNameAndShare?.share_of_property_owner}%`
                                  : '—'
                              }
                              labelWidth="60%"
                            />
                          </div>
                          <div className="col-12 md:col-6">
                            <InfoCard
                              label="Property Address"
                              value={userTaxFileData.property_address || '—'}
                              labelWidth="60%"
                            />
                          </div>
                        </>
                      )}

                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="BC Hydro Bill"
                          value={
                            generalExpensesList?.bc_hydro_bill
                              ? `$${generalExpensesList?.bc_hydro_bill}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Utilities Bill"
                          value={
                            generalExpensesList?.utilities
                              ? `$${generalExpensesList?.utilities}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Repairs Bill"
                          value={
                            generalExpensesList?.repairs
                              ? `$${generalExpensesList?.repairs}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Bank Interest"
                          value={
                            generalExpensesList?.bank_interest
                              ? `$${generalExpensesList?.bank_interest}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Property Tax"
                          value={
                            generalExpensesList?.property_tax
                              ? `$${generalExpensesList?.property_tax}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Insurance"
                          value={
                            generalExpensesList?.insurance
                              ? `$${generalExpensesList?.insurance}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Internet"
                          value={
                            generalExpensesList?.internet
                              ? `$${generalExpensesList?.internet}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <InfoCard
                          label="Fortis BC"
                          value={
                            generalExpensesList?.fortis_bc
                              ? `$${generalExpensesList?.fortis_bc}`
                              : '—'
                          }
                          labelWidth="60%"
                        />
                      </div>
                    </div>

                    {/* {otherExpensesDetail?.length > 0 && (
                      <>
                        <h4>Other Expenses</h4>
                        <div className="landlord-income-card">
                          <div className="landlord-grid">
                            {otherExpensesDetail?.map((expense: any, index: number) => (
                              <div key={index} className="landlord-item">
                                <div className="landlord-name">
                                  {" "}
                                  <span className="landlord-name">Name: </span>
                                  {expense?.name ? `${expense?.name}` : "-"}
                                </div>
                                <div className="landlord-amount">
                                  <span className="landlord-name">Amount: </span>
                                  {!window.cn(expense.amount) ? `$${expense.amount}` : "-"}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )} */}

                    {otherExpensesDetail?.length > 0 && (
                      <div className="mt-4">
                        <h5 className="mb-3">Other Expenses</h5>
                        <DataTable
                          value={otherExpensesDetail}
                          showGridlines
                          stripedRows
                          className="p-datatable-sm"
                          responsiveLayout="scroll"
                        >
                          <Column
                            field="name"
                            header="Expense Name"
                            headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                            style={{ padding: '7px 10px' }}
                            body={(rowData) => rowData?.name || '—'}
                          />
                          <Column
                            field="amount"
                            header="Amount"
                            headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                            style={{ padding: '7px 10px' }}
                            body={(rowData) =>
                              !window.cn(rowData.amount)
                                ? `$${rowData.amount}`
                                : '—'
                            }
                          />
                        </DataTable>
                      </div>
                    )}
                  </div>
                </Section>
              )}

              {/*Self Employed Expenses Section */}

              <div className="grid">
                <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                  <Section
                    title="Self Employed Information"
                    icon={Receipt}
                    sectionKey="employedExpenses"
                    scrollPositionRef={scrollPositionRef}
                    expandedSections={expandedSections}
                    setExpandedSections={setExpandedSections}
                  >
                    <div className="section-content-wrapper">
                      <div className="grid">
                        <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                          <InfoCard
                            label="Is Self Employed Income"
                            value={
                              userTaxFileData?.self_employed_income === true
                                ? 'Yes'
                                : 'No'
                            }
                            labelWidth={isMarried ? "40%" : "60%"}
                          />
                        </div>

                        {userTaxFileData?.self_employed_income === true && (
                          <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                            <InfoCard
                              label="Self Employed Income"
                              value={
                                userTaxFileData?.self_employed_amount
                                  ? `$${userTaxFileData?.self_employed_amount}`
                                  : '—'
                              }
                              labelWidth={isMarried ? "40%" : "60%"}
                            />
                          </div>
                        )}
                        {userTaxFileData?.self_employed_income === true && (
                          <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                            <InfoCard
                              label="Have Gst Number"
                              value={
                                userTaxFileData?.has_gst === true ? 'Yes' : 'No'
                              }
                              labelWidth={isMarried ? "40%" : "60%"}
                            />
                          </div>
                        )}

                        {userTaxFileData?.has_gst === true && (
                          <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                            <InfoCard
                              label="Gst Number"
                              value={userTaxFileData?.gst_no || '-'}
                              labelWidth={isMarried ? "40%" : "60%"}
                            />
                          </div>
                        )}

                        {userTaxFileData?.self_employed_income === true && (
                          <>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Gas Expense"
                                value={
                                  selfEmployedExpensesList?.gas_expense
                                    ? `$${selfEmployedExpensesList?.gas_expense}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Repairs Expense"
                                value={
                                  selfEmployedExpensesList?.repairs_expense
                                    ? `$${selfEmployedExpensesList?.repairs_expense}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Insurance Expense"
                                value={
                                  selfEmployedExpensesList?.insurance_expense
                                    ? `$${selfEmployedExpensesList?.insurance_expense}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Bill Expense"
                                value={
                                  selfEmployedExpensesList?.phone_bill_expenses
                                    ? `$${selfEmployedExpensesList?.phone_bill_expenses}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Meal Expense"
                                value={
                                  selfEmployedExpensesList?.meal_expenses
                                    ? `$${selfEmployedExpensesList?.meal_expenses}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>

                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Car Model"
                                value={
                                  selfEmployedExpensesList?.car_model
                                    ? `${selfEmployedExpensesList?.car_model}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Car Model Year"
                                value={
                                  selfEmployedExpensesList?.car_model_year
                                    ? `${selfEmployedExpensesList?.car_model_year}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Car Purchase Year"
                                value={
                                  selfEmployedExpensesList?.car_purchase_year
                                    ? `${selfEmployedExpensesList?.car_purchase_year}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Car Price Paid"
                                value={
                                  selfEmployedExpensesList?.car_price_paid
                                    ? `$${selfEmployedExpensesList?.car_price_paid}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      {selfEmployedOtherExpensesList?.length > 0 && (
                        <div className="mt-4">
                          <h5 className="mb-3">Self Employed Other Expense</h5>
                          <DataTable
                            value={selfEmployedOtherExpensesList}
                            showGridlines
                            stripedRows
                            className="p-datatable-sm"
                            responsiveLayout="scroll"
                          >
                            <Column
                              field="name"
                              header="Expense Name"
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={(rowData) => rowData?.name || '—'}
                            />
                            <Column
                              field="amount"
                              header="Amount"
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={(rowData) =>
                                !window.cn(rowData.amount)
                                  ? `$${rowData.amount}`
                                  : '—'
                              }
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </Section>
                </div>

                <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                  <Section
                    title="Work From Home Employed Expenses"
                    icon={Receipt}
                    sectionKey="workFromHomeExpense"
                    scrollPositionRef={scrollPositionRef}
                    expandedSections={expandedSections}
                    setExpandedSections={setExpandedSections}
                  >
                    <div className="section-content-wrapper">
                      <div className="grid">
                        <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                          <InfoCard
                            label="Have Work From Home"
                            value={
                              userTaxFileData?.work_from_home === true ? 'Yes' : 'No'
                            }
                            labelWidth={isMarried ? "40%" : "60%"}
                          />
                        </div>
                        <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                          <InfoCard
                            label="Are you long haul truck driver"
                            value={
                              userTaxFileData?.long_haul_truck_driver == '1'
                                ? 'Yes'
                                : 'No'
                            }
                            labelWidth={isMarried ? "40%" : "60%"}
                          />
                        </div>
                        {userTaxFileData?.work_from_home === true && (
                          <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                            <InfoCard
                              label="Claim Expenses For Work From Home"
                              value={
                                userTaxFileData?.claim_expense === true ? 'Yes' : 'No'
                              }
                              labelWidth={isMarried ? "40%" : "80%"}
                            />
                          </div>
                        )}

                        {userTaxFileData?.work_from_home === true && (
                          <>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Internet Bill"
                                value={
                                  wfhExpensesList?.internet_bill
                                    ? `$${wfhExpensesList?.internet_bill}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Insurance Bill"
                                value={
                                  wfhExpensesList?.insurance_bill
                                    ? `$${wfhExpensesList?.insurance_bill}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Equipement Bill"
                                value={
                                  wfhExpensesList?.equipment_bill
                                    ? `$${wfhExpensesList?.equipment_bill}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Stationery Bill"
                                value={
                                  wfhExpensesList?.stationery_bill
                                    ? `$${wfhExpensesList?.stationery_bill}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Utilities Bill"
                                value={
                                  wfhExpensesList?.utilities_bill
                                    ? `$${wfhExpensesList?.utilities_bill}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Hydro Bill"
                                value={
                                  wfhExpensesList?.hydro_bill
                                    ? `$${wfhExpensesList?.hydro_bill}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                            <div className={isMarried ? "col-12" : "col-12 md:col-6"}>
                              <InfoCard
                                label="Rent Bill"
                                value={
                                  wfhExpensesList?.rent_bill
                                    ? `$${wfhExpensesList?.rent_bill}`
                                    : '—'
                                }
                                labelWidth={isMarried ? "40%" : "60%"}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      {wfhOtherExpensesList?.length > 0 && (
                        <div className="mt-4">
                          <h5 className="mb-3">Work From Home Employed Other Expense</h5>
                          <DataTable
                            value={wfhOtherExpensesList}
                            showGridlines
                            stripedRows
                            className="p-datatable-sm"
                            responsiveLayout="scroll"
                          >
                            <Column
                              field="name"
                              header="Expense Name"
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={(rowData) => rowData?.name || '—'}
                            />
                            <Column
                              field="amount"
                              header="Amount"
                              headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                              style={{ padding: '7px 10px' }}
                              body={(rowData) =>
                                !window.cn(rowData.amount)
                                  ? `$${rowData.amount}`
                                  : '—'
                              }
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </Section>
                </div>
              </div>

              {/* Documents Section */}
              <Section
                title="Taxpayer Documents"
                icon={FileText}
                sectionKey="documents"
                scrollPositionRef={scrollPositionRef}
                expandedSections={expandedSections}
                setExpandedSections={setExpandedSections}
              >
                <div className="mt-4">

                  {pageLoad ? (
                    <div className="crud-demo">
                      <DataTable
                        value={documentList}
                        showGridlines
                        dataKey="id"
                        stripedRows
                        responsiveLayout={'scroll'}
                        className="datatable-responsive p-datatble-sm"
                        emptyMessage="No Document Found"
                        filters={globalFieldFilter}
                        onFilter={(e) => setGlobalFieldFilter(e.filters)}
                        removableSort
                      >
                        {TaxListDetailColumns.map((col, i) => {
                          if (col.field === 'file_url') {
                            return (
                              <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                style={{ padding: '7px 10px' }}
                                body={actionBodyTemplate}
                              />
                            );
                          } else if (col.field === 'type') {
                            return (
                              <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                style={{ padding: '7px 10px' }}
                                body={(rowData) => {
                                  return (
                                    <span>
                                      {rowData?.type || '—'}
                                      {rowData?.type?.toLowerCase() === 't4' &&
                                        rowData?.page_count
                                        ? ` (${rowData?.page_count} ${rowData?.page_count === 1
                                          ? 'page'
                                          : 'pages'
                                        })`
                                        : ''}
                                    </span>
                                  );
                                }}
                              />
                            );
                          } else if (col.field === 'review_status') {
                            return (
                              <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                style={{ padding: '7px 10px' }}
                                body={documentStatusTemplate}
                              />
                            );
                          } else if (col.field === 'upload_doc') {
                            return (
                              <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                style={{ padding: '7px 10px' }}
                                body={uploadFileTemplate}
                              />
                            );
                          } else {
                            return (
                              <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                                style={{ padding: '7px 10px' }}
                              />
                            );
                          }
                        })}
                      </DataTable>
                    </div>
                  ) : (
                    <div className="crud-demo">
                      <DataTable value={Skeletonitems}>
                        {TaxListDetailColumns.map((col) => (
                          <Column
                            key={col.field}
                            field={col.field}
                            header={col.header}
                            headerStyle={{ padding: '7px 10px', fontWeight: 'bold' }}
                            style={{ padding: '7px 10px' }}
                            body={SkeletonbodyTemplate}
                          />
                        ))}
                      </DataTable>
                    </div>
                  )}
                </div>
              </Section>
            </>
          )}
        </div>
      </div>

      {/* document status change Dialogs */}
      <Dialog
        visible={documentStatusDialog}
        style={{ width: '500px' }}
        header="Document Status Update"
        className="mx-3 lg:mx-0"
        draggable={false}
        modal
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideDocStatusDialog}
            />
            <Button
              label="Confirm"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={documentStatusUpdateApiCall}
              loading={submitLoading}
            />
          </>
        }
        onHide={hideDocStatusDialog}
      >
        <div className="flex align-items-center justify-content-start ">
          {isHold === 1 && (
            <h5 style={{ fontSize: '16px' }}>
              Note: Are you sure you don't want to approve the document
            </h5>
          )}
        </div>
      </Dialog>

      {/* edit name dialog */}
      <Dialog
        visible={editNameDialog}
        style={{ width: '480px' }}
        header={
          editNameField === 'first_name' ? 'Edit First Name' : editNameField === 'middle_name' ? 'Edit Middle Name' : 'Edit Last Name'
        }
        className="mx-3 lg:mx-0"
        draggable={false}
        modal
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideEditNameDialog}
            />
            <Button
              label="Update"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={saveEditNameHandler}
              loading={editNameLoading}
            />
          </>
        }
        onHide={hideEditNameDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* First Name - visible only when editing first name */}
          {editNameField === 'first_name' && (
            <div className="field col-12">
              <label htmlFor="edit_first_name">
                First Name <span className="required">*</span>
              </label>
              <InputText
                id="edit_first_name"
                value={editFirstName}
                placeholder="Enter First Name"
                onChange={(e) => {
                  setEditFirstName(e.target.value);
                  setErrors((prev: any) => ({ ...prev, first_name: '' }));
                }}
                className={errors?.['first_name'] ? 'p-invalid' : ''}
              />
              <small className="p-invalid-txt">{errors?.['first_name']}</small>
            </div>
          )}
          {/* Middle Name - visible only when editing middle name */}
          {editNameField === 'middle_name' && (
            <div className="field col-12">
              <label htmlFor="edit_middle_name">
                Middle Name <span className="required">*</span>
              </label>
              <InputText
                id="edit_middle_name"
                value={editFirstName}
                placeholder="Enter Middle Name"
                onChange={(e) => {
                  setEditFirstName(e.target.value);
                  setErrors((prev: any) => ({ ...prev, middle_name: '' }));
                }}
                className={errors?.['middle_name'] ? 'p-invalid' : ''}
              />
              <small className="p-invalid-txt">{errors?.['middle_name']}</small>
            </div>
          )}
          {/* Last Name - visible only when editing last name */}
          {editNameField === 'last_name' && (
            <div className="field col-12">
              <label htmlFor="edit_last_name">
                Last Name <span className="required">*</span>
              </label>
              <InputText
                id="edit_last_name"
                value={editLastName}
                placeholder="Enter Last Name"
                onChange={(e) => {
                  setEditLastName(e.target.value);
                  setErrors((prev: any) => ({ ...prev, last_name: '' }));
                }}
                className={errors?.['last_name'] ? 'p-invalid' : ''}
              />
              <small className="p-invalid-txt">{errors?.['last_name']}</small>
            </div>
          )}
        </div>
      </Dialog>

      {/* file upload dialog */}
      <Dialog
        visible={fileUploadDialog}
        style={{ width: '500px' }}
        header="Upload Document"
        className="mx-3 lg:mx-0"
        modal
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideFileUploadDialog}
            />
            <Button
              label="Upload"
              icon="pi pi-check"
              className="common-primary-button"
              onClick={fileUploadSubmit}
              loading={submitLoading}
            />
          </>
        }
        onHide={hideFileUploadDialog}
      >
        <div className="grid">
          <div className="field col-12 md:col-12">
            <label htmlFor="file">
              Upload Document <span className="required">*</span>
            </label>
            <FileUploader
              name="file_upload"
              onInputChange={onInputFileChange}
              multiple={false}
              maxSize={10}
              value={selectedFile}
            />
            <small className="p-invalid-txt">{errors?.['selectedFile']}</small>
          </div>
        </div>
      </Dialog>

      {/* {pageLoad === false && <Loader />} */}
    </>
  );
};

export default UserTaxDetail;
